var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',_vm._g(_vm._b({attrs:{"href":_vm.href}},'a',_vm.attrs,false),_vm.listeners),[_vm._t("default")],2),_c('v-icon',{attrs:{"x-small":""}},[_vm._v("mdi-open-in-new")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }